export default __webpack_public_path__ + "static/media/photo--lg--kickoff6.526b840b.jpg";